import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { DialogComponent } from '../../../dialog/components/dialog/dialog.component';
import { MatDialogConfig } from '@angular/material/dialog';
import { SvgIconsEnum } from '@/types/svg-icons.enum';

@Component({
  selector: 'tpt-confirm-destruction-dialog',
  templateUrl: './confirm-destruction-dialog.component.html',
  styleUrls: ['./confirm-destruction-dialog.component.scss']
})
export class ConfirmDestructionDialogComponent {

  public title: string;

  public description: string;

  public action: string;

  public cancelText = 'BUTTON.CANCEL';

  public type: string;

  public icon: SvgIconsEnum;

  public buttonType: 'primary' | 'error' | 'secondary' | 'tertiary' | 'alternative' = 'error';

  @Output()
  public readonly actionDecline = new EventEmitter<string>();

  @Output()
  public readonly actionApprove = new EventEmitter<string>();

  @ViewChild(DialogComponent)
  public dialog: DialogComponent;

  private readonly className = 'tpt-confirm-destruction-dialog';

  private config: MatDialogConfig = {
    width: '620px',
    maxWidth: 'calc(100vw - 32px)',
  };

  public open(type: string,
              title: string,
              description: string,
              buttonType: 'primary' | 'error' | 'secondary' | 'tertiary' | 'alternative',
              action: string,
              cancel?: string,
              icon?: SvgIconsEnum): void {
    this.type = type;
    this.title = title;
    this.description = description;
    this.buttonType = buttonType;
    this.action = action;
    this.icon = icon;
    this.cancelText = cancel || 'BUTTON.CANCEL';
    if (type === 'DELETE_PARTICIPANT') {
      this.config.panelClass = 'chat-dialog-align';
    }
    this.dialog.config = this.config;
    this.dialog.open(this.className);
  }

  public close(): void {
    this.dialog.close();
  }

  public declineAction(): void {
    this.actionDecline.emit(this.type);
    this.close();
  }

  public approveAction(): void {
    this.actionApprove.emit(this.type);
    this.close();
  }
}
